import {
  SubWorkflowStepMode,
  SysEmailRecipientMode,
  WorkflowStepType,
  WorkflowTriggerType,
} from '@commenda/types';
import { TDataSourceCall } from '@commenda/types/src/workflow/dsl/datasource';
import { TMapping } from '@commenda/types/src/workflow/dsl/mapping';
import { NodeProps } from '@xyflow/react';

export const TRIGGER_NODE_TYPE = 'trigger' as const;

export type TBaseNodeData = {
  id: string;
  type: WorkflowStepType;
  name: string;
};

export type TSysEmailNodeData = TBaseNodeData & {
  type: WorkflowStepType.SYS_EMAIL;
  recipientMode?: SysEmailRecipientMode;
};

export type TSubWorkflowNodeData = TBaseNodeData & {
  type: WorkflowStepType.SYS_SUB_WORKFLOW;
  mode: SubWorkflowStepMode;
  childWorkflowTemplateVersionId: string;
  dataSources?: TDataSourceCall[];
  inputMapping?: TMapping[];
  contextProjection?: TMapping[];
};

export type TTriggerNodeData = {
  id: string;
  type: typeof TRIGGER_NODE_TYPE;
  triggerType: WorkflowTriggerType;
  name: string;
  eventType?: string;
};

export type TNodeData = TBaseNodeData;

export type TNodeTemplate = {
  label: string;
  icon: React.ReactNode;
  bgClassName: string;
  stepType: WorkflowStepType;
  defaultData: Omit<TBaseNodeData, 'id'> | Omit<TSysEmailNodeData, 'id'>;
};

export type TTriggerNodeTemplate = {
  label: string;
  icon: React.ReactNode;
  bgClassName: string;
  nodeType: typeof TRIGGER_NODE_TYPE;
  defaultData: Omit<TTriggerNodeData, 'id'>;
};

export type TNodeProps = NodeProps & {
  data: TNodeData;
};

export type TTriggerNodeProps = NodeProps & {
  data: TTriggerNodeData;
};

export type TEdgeCondition = {
  condition: string;
};

export type TEdgeBaseData = {
  condition?: TEdgeCondition;
  isDefault?: boolean;
  label?: string;
};

export type THumanRedirectNodeData = TBaseNodeData & {
  type: WorkflowStepType.HUMAN_REDIRECT;
  redirectUrl: string;
};
export type TSelectedEntity = {
  type: 'node' | 'edge' | 'trigger';
  id: string;
};

export type TPromptKey = 'systemPrompt' | 'userPrompt';
export type TPromptMappingKey =
  | 'systemPromptValueMapping'
  | 'userPromptValueMapping';
